
<div class="progress-outer">
    <div class="progress-inner" [style.width]="whichProgress(progress) + '%'" [style.background-color]="degraded == null ? color : whichColor(progress)">
      <ng-container *ngIf="!disabledP"> 
        {{whichProgress(progress)}}%
      </ng-container>
      <ng-container *ngIf="disabledP"> 
        {{whichProgress(progress)}}
      </ng-container>
    </div>
  </div>
  